import { ISourceCriteria } from '_/features/flows/common/types/flow.types';

export const setFlowType = (val) => (val?.definition?.chains?.length > 0 ? 'CHAINED' : val.type);

export function cleanupSourceCriteria(sourceCriteria: ISourceCriteria | null): ISourceCriteria | null {
  const filtered = sourceCriteria?.filters
    ?.map((item) => {
      const cleanedParameters = Object.fromEntries(Object.entries(item.parameters).filter(([, value]) => value));
      return { ...item, parameters: cleanedParameters };
    })
    .filter((item) => Object.keys(item.parameters).length > 0);

  return filtered?.length ? { ...sourceCriteria, filters: filtered } : null;
}

export const chunkInputProps = {
  step: '0.01',
  min: 0.1,
  max: 999.99,
};
